import React, { Suspense } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { Routing } from 'services/action';
import { Skeletons } from 'ui/components/skeleton';

const Map = React.lazy(() =>
  import('ui/components/mapbox/map.manifest.detail')
);

export const SectionMap = ({ manifest }) => {
  const Dispatch = useDispatch();

  const [routing, setRouting] = React.useState(null);
  const [key, setKey] = React.useState('planning');
  const [loading, setLoading] = React.useState(true);

  const $onLoad = async (e) => {
    if (manifest?.status !== 'completed') return;

    const req = await Dispatch(Routing.$manifest(e));

    if (req?.message === 'success') {
      setRouting(req?.data);
    }
  };

  React.useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, [key]);

  React.useEffect(() => {
    if (!manifest || !manifest?.id) return;

    $onLoad(manifest?.id);
  }, [manifest]);

  if (manifest?.status === 'completed') {
    return (
      <div className="border-bottom">
        <Tabs
          className="tabs"
          justify
          activeKey={key}
          onSelect={(k) => setKey(k)}
        >
          <Tab
            eventKey="planning"
            title="Planning"
            tabClassName="section-title bg-white align-items-center justify-content-center"
          >
            {loading ? (
              <Skeletons height="500px" />
            ) : (
              <Suspense fallback={<div>Loading...</div>}>
                <Map legs={manifest?.legs} centerDynamic={false} />
              </Suspense>
            )}
          </Tab>
          <Tab
            eventKey="actual"
            title="Actual"
            tabClassName="bg-white section-title align-items-center justify-content-center "
          >
            <div className="">
              {loading ? (
                <Skeletons height="500px" />
              ) : (
                <Suspense fallback={<div>Loading...</div>}>
                  <Map legs={routing?.actual?.legs} centerDynamic={false} />
                </Suspense>
              )}
            </div>
          </Tab>
        </Tabs>
      </div>
    );
  }

  return (
    <div className="bg-white border-top border-bottom" key={manifest?.id}>
      {loading ? (
        <Skeletons height="500px" />
      ) : (
        <Suspense fallback={<div>Loading...</div>}>
          <Map legs={manifest?.legs} centerDynamic={false} />
        </Suspense>
      )}
    </div>
  );
};
